export const CONFIG_UNAVAILABLE_MESSAGE =
  'Config no longer available in this system. It may have been deleted or moved.'

export const CONFIG_NOT_FOUND_MESSAGE = 'Config not found.'

export const CONFIG_MALFORMED_RESOLUTION_MESSAGE = 'Unable to compute resolution: config is malformed.'

export const CONFIG_MALFORMED_RELATIONS_MESSAGE = 'Unable to compute relations: config is malformed.'
